import { Controller } from "@hotwired/stimulus";
import { Modal } from "bootstrap";

export default class extends Controller {
  static values = {
    newHome: Boolean,
    userCountry: String,
    cartsData: String,
    showGeneratorLanding: Boolean,
    locale: String,
    isRegionalDomain: Boolean,
  };

  url =
    "https://www.youtube.com/embed/CGAxjjV6rSs?autoplay=1&amp;modestbranding=1&amp;showinfo=0%22";
  // videoModal = new Modal(this.videoModalTarget);
  static targets = ["videoModal", "videoFrame", "dataSrc", "cart"];

  connect() {
    this.showUnderline();
    this.locale =
      this.localeValue || window.location.pathname.split("/")[1].toUpperCase();
    this.cartsByCountryUpdate();
    this.sendOpenEvents();
    let observe = true;
    const imageObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && observe) {
            this.dataSrcTargets.forEach(
              (image) => (image.src = image.dataset.src),
            );
            observe = false;
          }
        });
      },
      {
        rootMargin: "50px 0px 50px",
      },
    );
    this.dataSrcTargets.forEach((img) => imageObserver.observe(img));
    this.observeSection();
    if (!this.isRegionalDomainValue) {
      this.sendGeneratorLandingEvents();
    }
  }

  observeSection() {
    const target = document.getElementById("LogoQrSection");
    if (!target) return;

    let called = false;

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !called) {
          called = true;
          this.fetchTypes();
          observer.disconnect();
        }
      });
    }, { threshold: 0.1 });

    observer.observe(target);
  }
  fetchTypes(){
    fetch('/index-get-types', {
      method: 'GET',
    })
      .then(res => {
        if (!res.ok) throw new Error('Network response was not ok: ' + res.status);
        return res.text();
      })
      .then(html => {
        document.getElementById("specifiedTypes").innerHTML = html;

      })
      .catch(err => {
        console.error('Fetch error:', err);
      });

  }
  closeVideoModal() {
    this.videoModal.hide();
    this.videoFrameTarget.src = "";
  }

  openVideoModal(e) {
    this.videoModal.show();
    this.videoFrameTarget.src = this.url;
    this.gtagClick(e);
  }

  gtagClick(e) {
    e.preventDefault();

    const element = e.target.closest("[data-new-landing-target]");
    const targetValue = element?.dataset.newLandingTarget || null;

    const targetUrl = e.target.closest("a")?.href || null;

    let navigated = false;
    const navigate = () => {
      if (navigated || !targetUrl) {
        console.warn("No target URL found for navigation");
        return;
      }
      navigated = true;
      window.location.href = targetUrl;
    };

    const commonParams = {
      site_language:
        this.locale && this.locale.length > 2 ? "EN" : this.locale || "EN",
      event_callback: navigate,
      event_timeout: 200,
      transport_type: "beacon",
    };


    if (typeof gtag !== "function") {
      console.warn("Google Analytics gtag is not available");
      navigate();
      return;
    }

    let redditEventName = null;

    if (e.params?.label === "download_appstore") {
      gtag("event", "click_download_app", {
        ...commonParams,
        store: "App Store",
        place: "landing",
      });
      redditEventName = "click_download_app";
    } else if (e.params?.label === "download_googleplay") {
      gtag("event", "click_download_app", {
        ...commonParams,
        store: "Google Play",
        place: "landing",
      });
      redditEventName = "click_download_app";
    } else if (e.params?.label === "button_refer") {
      gtag("event", "click_become_partner", commonParams);
      redditEventName = "click_become_partner";
    } else if (e.params?.label === "button_ticket") {
      gtag("event", "navigate_to_service", {
        ...commonParams,
        service: "ME TICKET",
        place: "landing",
      });
      redditEventName = "navigate_to_service_ticket";
    } else if (e.params?.label === "button_museum") {
      gtag("event", "navigate_to_service", {
        ...commonParams,
        service: "ME MUSEUM",
        place: "landing",
      });
      redditEventName = "navigate_to_service_museum";
    } else if (targetValue === "cart") {
      gtag("event", e.params?.event || "click_cart", {
        ...commonParams,
        type: e.params?.label || "unknown",
      });
      redditEventName = e.params?.event || "click_cart";
    } else {
      gtag("event", e.params?.event || "click_unknown", commonParams);
      redditEventName = e.params?.event || "click_unknown";
    }


    if (typeof rdt === "function" && redditEventName) {
      rdt("track", "Custom", { customEventName: redditEventName });
    }


    setTimeout(() => {
      if (!navigated) navigate();
    }, 200);
  }


  viewAllTemplatesBtn() {
    gtag("event", "view_more_templates", {
      site_language: (this.locale.length > 2 || !this.locale ) ?  "EN" : this.locale,
  });
    try {
      rdt("track", "Custom", { customEventName: "view_more_templates" });
    } catch (err) {
      console.warn("Reddit pixel not initialized yet");
    }
  }

  generateNewBtn() {
    gtag("event", "open_new_gen", {
      site_language: (this.locale.length > 2 || !this.locale ) ?  "EN" : this.locale,
      place: "landing"
    });
    try {
      rdt("track", "Custom", { customEventName: "open_new_gen" });
    } catch (err) {
      console.warn("Reddit pixel not initialized yet");
    }
  }


  sendOpenEvents() {
    gtag("event", "open_new_main", {
      site_language:(this.locale.length > 2 || !this.locale ) ?  "EN" : this.locale,
    });
    try {
      rdt("track", "Custom", { customEventName: "open_new_main" });
    } catch (err) {
      console.warn("Reddit pixel not initialized yet");
    }
  }

  cartsByCountryUpdate() {
    const updateCart = (cart, cartData, isTextCart = true) => {
      if (isTextCart) {
        cart.querySelector(".header-text").innerText = cartData.title;
        let tooltipTrigger = cart.querySelector(".header-img-question");
        if (cartData.popover!=null && tooltipTrigger!=null) {
          tooltipTrigger.setAttribute('data-bs-content', cartData.popover);
          let popover = new bootstrap.Popover(tooltipTrigger);
        } else if(tooltipTrigger!=null  ) {
          tooltipTrigger.classList.add("d-none");
        }
      }
      cart.querySelector(".header-img").src =
        !isTextCart && cartData.img2 ? cartData.img2 : cartData.img;
      cart.querySelector(".header-img").alt = cartData.label;
      cart.href = cartData.href;

      cart.dataset.newLandingLabelParam = cartData.label;

    };


    // const country = this.userCountryValue;

    const cartsData = JSON.parse(this.cartsDataValue);
    if (this.cartTargets.length === 0) return;

    updateCart(this.cartTargets[0], cartsData.link);
    updateCart(this.cartTargets[1], cartsData.image);
    updateCart(this.cartTargets[2], cartsData.pdf);
    updateCart(this.cartTargets[3], cartsData.whatsapp, false);
    updateCart(this.cartTargets[4], cartsData.audio);
    updateCart(this.cartTargets[5], cartsData.vcard);
    updateCart(this.cartTargets[6], cartsData.map, false);
    updateCart(this.cartTargets[7], cartsData.linkList);
    updateCart(this.cartTargets[8], cartsData.text);
    updateCart(this.cartTargets[9], cartsData.instagram, false);
    updateCart(this.cartTargets[10], cartsData.youtube, false);
    updateCart(this.cartTargets[11], cartsData.email);
    updateCart(this.cartTargets[12], cartsData.store);


  }
  showUnderline(){
  const parent = document.getElementById('observe-this');
  const span = parent.querySelector('.animated-span');

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        span.classList.add('move');
      } else {
        span.classList.remove('move');
      }
    },
    {
      root: null,
      threshold: 0,
      rootMargin: "0px 0px -200px 0px"
    }
  );

  observer.observe(parent);
}

  sendGeneratorLandingEvents() {
    gtag("event", this.showGeneratorLandingValue ? "mainform_show_yes" : "mainform_show_no", {
      site_language: (this.locale.length > 2 || !this.locale ) ?  "EN" : this.locale,
    });
  }
}
